import { render } from "./BannerManagement.vue?vue&type=template&id=11428fc3&scoped=true"
import script from "./BannerManagement.vue?vue&type=script&lang=js"
export * from "./BannerManagement.vue?vue&type=script&lang=js"

import "./BannerManagement.vue?vue&type=style&index=0&id=11428fc3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11428fc3"]])

export default __exports__